const constraintsSummaryLocale = {
  constraintsSummary: {
    productionConstraints: "Contraintes de production",
    definitive: "Désactivation définitive",
    temporary: "Désactivation temporaire",
    links: "Désactivation par voies links",
    planning: "Planning",
    adjusting: "Aménagement des Modulations",
    manage: "Gestion des contraintes",
    nothing: "Aucune contrainte",
  },
};

export type ConstraintsSummaryLocale = typeof constraintsSummaryLocale;
export default constraintsSummaryLocale;
